import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("lg_user") || "null"); } catch { return null; }
  });
  const [workspace, setWorkspace] = useState(() => {
    try { return JSON.parse(localStorage.getItem("lg_workspace") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const persist = (token, u, w) => {
    if (token) localStorage.setItem("lg_token", token);
    if (u) localStorage.setItem("lg_user", JSON.stringify(u));
    if (w) localStorage.setItem("lg_workspace", JSON.stringify(w));
    setUser(u || null);
    setWorkspace(w || null);
  };

  const signup = useCallback(async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/signup", payload);
      persist(data.token, data.user, data.workspace);
      return data;
    } finally { setLoading(false); }
  }, []);

  const login = useCallback(async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", payload);
      persist(data.token, data.user, data.workspace);
      return data;
    } finally { setLoading(false); }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("lg_token");
    localStorage.removeItem("lg_user");
    localStorage.removeItem("lg_workspace");
    setUser(null);
    setWorkspace(null);
  }, []);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("lg_token")) return;
    try {
      const { data } = await api.get("/auth/me");
      persist(null, data.user, data.workspace);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AuthContext.Provider value={{ user, workspace, loading, signup, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
